export default __webpack_public_path__ + "static/media/suitcase.9479ca7e.svg";